import React from 'react'
import { gql, useQuery } from '@apollo/client'
import { MutationHandlerError } from '../utils/errors'
import { MenuImportCounts, MenuImportItem } from '../mutations/importMenu'

const MENU_IMPORT_REPORT_QUERY = gql`
	query MenuImportReport($restaurantId: ID!, $source: String!) {
		menuImportReport(restaurantId: $restaurantId, source: $source) {
			source
			counts {
				categories
				products
				optionGroups
				options
			}
			sourceCategoryCount
			sourceProductCount
			sourceOptionGroupCount
			sourceOptionCount
			itemsByCategory {
				title
				items {
					name
					type
					status
					gaps {
						label
						reasons
					}
				}
			}
		}
	}
`

// `counts` ist, was importiert wird bzw. wurde — importMenu schreibt genau diesen Plan.
export type MenuImportReport = {
	source: string
	counts: MenuImportCounts
	sourceCategoryCount: number
	sourceProductCount: number
	sourceOptionGroupCount: number
	sourceOptionCount: number
	itemsByCategory: {
		title: string
		items: MenuImportItem[]
	}[]
}

// Immer frisch geladen: der Bericht hängt an <source>.json und daran, ob schon importiert wurde. Ein
// Fehler beendet das Laden; `errors` passt direkt in handleMutationError.
export const useMenuImportReport = (
	restaurantId: string | null,
	source: string
): { report: MenuImportReport | null; loading: boolean; errors: MutationHandlerError } => {
	const { data, error } = useQuery(MENU_IMPORT_REPORT_QUERY, {
		variables: { restaurantId, source },
		skip: restaurantId === null,
		fetchPolicy: 'network-only',
	})
	return React.useMemo(
		() => ({
			report: (data?.menuImportReport as MenuImportReport | null | undefined) ?? null,
			loading: restaurantId !== null && data === undefined && error === undefined,
			errors: error
				? error.graphQLErrors.length > 0
					? error.graphQLErrors
					: 'NETWORK_ERROR'
				: null,
		}),
		[restaurantId, data, error]
	)
}
